import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState, fmtDate } from "../components/common";
import { Card } from "../components/ui/card";
import {
  SignIn, ShieldWarning, Scan, FileText, Buildings, Target, User, Gear, SealCheck,
} from "@phosphor-icons/react";

const ICONS = {
  "auth.login": { icon: SignIn, color: "#3b82f6" },
  "consent.signed": { icon: SealCheck, color: "#ef4444" },
  "scan.queued": { icon: Scan, color: "#3b82f6" },
  "scan.completed": { icon: Scan, color: "#22c55e" },
  "report.generated": { icon: FileText, color: "#3b82f6" },
  "workspace.created": { icon: Buildings, color: "#3b82f6" },
  "target.created": { icon: Target, color: "#3b82f6" },
  "user.created": { icon: User, color: "#3b82f6" },
  "system.seed": { icon: Gear, color: "#64748b" },
};

export default function Audit() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/audit").then((r) => setLogs(r.data)); }, []);

  return (
    <div className="fade-up">
      <PageHeader
        overline="Immutable trail"
        title="Audit Log"
        subtitle="Every login, scan, consent sign-off and action. Shipped to Azure Log Analytics (Australia) in production."
      />

      {logs.length === 0 ? (
        <EmptyState icon={ShieldWarning} title="No activity yet" />
      ) : (
        <Card className="bg-[#0f172a] border-[#1e293b] rounded-lg p-2">
          <div className="relative pl-4">
            <div className="absolute left-[26px] top-2 bottom-2 w-px bg-[#1e293b]" />
            {logs.map((l) => {
              const meta = ICONS[l.action] || { icon: Gear, color: "#64748b" };
              const consent = l.action === "consent.signed";
              return (
                <div key={l.id} data-testid={`audit-row-${l.id}`}
                  className={`relative flex gap-3 rounded-md px-3 py-3 hover:bg-slate-800/40 transition-colors duration-150 ${consent ? "bg-red-500/5" : ""}`}>
                  <div className="z-10 h-6 w-6 shrink-0 rounded-full flex items-center justify-center border"
                    style={{ backgroundColor: `${meta.color}18`, borderColor: `${meta.color}55` }}>
                    <meta.icon size={13} weight="bold" style={{ color: meta.color }} />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5">
                      <span className="font-mono text-xs px-1.5 py-0.5 rounded" style={{ color: meta.color, backgroundColor: `${meta.color}12` }}>
                        {l.action}
                      </span>
                      <span className="text-sm text-slate-300">{l.detail}</span>
                    </div>
                    <div className="text-xs text-slate-500 mt-0.5">
                      {l.actor_name || "system"}{l.actor_role ? ` · ${l.actor_role}` : ""} · {fmtDate(l.timestamp)}
                      {l.ip ? ` · ${l.ip}` : ""}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
